import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import * as XLSX from 'xlsx';


const DataTablekpisaleproduct = ({ listProducts, isClicked, finalMonth, finalYear, ttQte }) => {
  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "barcode",
      text: "Produits",
      headerAlign: "center",
      formatter: (cell, row) => `${row.barcode} - ${row.name}`,
    },
    {
      dataField: "count",
      text: "Nbr de fois facturé",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "total_quantity",
      text: "Qte totale",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "nm_facture",
      text: "NM/Facture",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) =>
        nombreMoyenParCommande(row.total_quantity, row.count),
    },
    {
      dataField: "totalAmountInitialPrice",
      text: "CA prévisionel",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "totalAmountSellingPrice",
      text: "CA généré",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "is_pack",
      text: "Type",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (
        <span className="badge bg-success">{testPack(cell)}</span>
      ),
    },
    {
      dataField: "promotionPercentage",
      text: "Promo",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (
        <span className="badge bg-warning">
          {extractDigitsAfterDecimal(cell)}%
        </span>
      ),
    },
  ];

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
    hideSizePerPage: true,
  };
  // const MyExportCSV = (props) => {
  //   const handleClick = () => {
  //     props.onExport();
  //   };
  //   return (
  //     <div>
  //       <button className="btn btn-dark" onClick={handleClick}>
  //         <i class="fas fa-download"></i> Télécharger CSV
  //       </button>
  //     </div>
  //   );
  // };
  const CustomExportButton = ({ data, fileName }) => {
    const handleExport = () => {
      // Filter the data to include only the required fields
      const filteredData = data.map((item) => ({
        "Produit": item.barcode+"-"+item.name,
        "Nbr de fois facturé": item.count,
        "Qte totale": item.total_quantity ,
        "NM/Facture": nombreMoyenParCommande(item.total_quantity, item.count),
        "CA prévisionel": item.totalAmountInitialPrice,
        "CA généré": item.totalAmountSellingPrice,
        "Type": testPack(item.is_pack),
        "Promo": extractDigitsAfterDecimal(item.promotionPercentage)+"%",

      }));
      
      // Convert the filtered data to a worksheet
      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Export the workbook to an Excel file
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    return (
      <button onClick={handleExport} className="btn btn-dark">
        <i className="fas fa-download"></i> Télécharger Excel
      </button>
    );
  };
  return (
    <div>
      {isClicked && Array.isArray(listProducts) && listProducts.length > 0 && (
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">
              Résultat de l'année Vente: {finalMonth}/{finalYear} : {ttQte}
            </h3>
          </div>
          <div className="card-body">
            <ToolkitProvider
              keyField="barcode"
              data={listProducts}
              columns={columns}
              search
              exportCSV
            >
              {(props) => (
                <>
                  <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <CustomExportButton data={listProducts} fileName="produits" />
                </div>

              </div>
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    striped
                    hover
                    condensed
                  />
                </>
              )}
            </ToolkitProvider>
          </div>
        </div>
      )}
    </div>
  );
};

const nombreMoyenParCommande = (totalQuantity, count) => {
  return (totalQuantity / count).toFixed(2);
};

const testPack = (isPack) => {
  return isPack ? "Pack" : "Produit";
};

const extractDigitsAfterDecimal = (number) => {
  return number ? number.toFixed(2) : "0";
};

export default DataTablekpisaleproduct;
